(function() {
    'use strict';

    angular.module('szallodak-room', ['dropzone', 'dropzonelight'])
        .config(config);

    function config() {
    }
})();
